module.exports = __webpack_public_path__ + "1890fe647a4665476e6f169a613c3cef.svg";